<template>
  <div class="profile__main-container">
    <div class="profile__body-container">
      <div class="profile__left-pane" >
        <PhotoViewer
          class="profile-photo"
          @onPhotoChange="onPhotoChange"
          @onPhotoRemove="onPhotoRemove"
          :isBusy="isProfilePhotoBusy"
          :imageUrl="personnelPhotoUrl"
          :text="`${user.userable ? user.userable.firstName.charAt(0) : ''}${user.userable ? user.userable.lastName.charAt(0) : ''}`"
        />
        <div class="profile-name">{{`${user.userable ? user.userable.name : ''}`}}</div>
        <div class="profile-username">{{ user ? user.username : ''}}</div>
        <div class="profile-usergroup">{{ user.userGroup ? user.userGroup.name : ''}}</div>
        <ul class="profile-nav">
          <li class="profile-nav-item" :class="{ active: selectedIndex === index}" v-for="(nav, index) in profileNavs" :key="index" @click="onNavIndexChange(index)" >
            <div><v-icon :name="nav.icon" class="profile-nav-item-icon"/>{{ nav.title }}</div>
          </li>
        </ul>
      </div>
      <div class="profile__right-pane">
        <loading
          :can-cancel="false" 
          :is-full-page="false"
          :active.sync="isLoading" >
        </loading>

        <div class="profile__header">
          <div class="profile__nav-title" >{{ profileNavs[selectedIndex].title }}</div>
          <div class="profile__nav-sub-title" >{{ profileNavs[selectedIndex].subTitle }}</div>
          <div class="profile__button" v-show="selectedIndex === 0 || selectedIndex === 1">
            <v-icon class="profile__button-icon" @click="isEditing = true" v-if="!isEditing & !isProcessing" name="pencil-alt"></v-icon>
            <v-icon class="profile__button-icon" @click="onSave()" v-if="isEditing & !isProcessing" name="save" ></v-icon>
            <v-icon class="profile__button-icon" :disabled="isProcessing" v-if="isProcessing" name="sync" spin></v-icon>
          </div>
        </div>
        
        <div class="profile__section" :key="1" v-if="selectedIndex === 0">
          <b-row>
            <b-col md=4>
              <b-form-group>
                <label class="required">Lastname : </label>
                <b-form-input 
                  :disabled="!isEditing" 
                  v-model="forms.personnel.fields.lastName"
                  :state="forms.personnel.states.lastName"
                  debounce="500" />
                  <b-form-invalid-feedback>
                    {{ forms.personnel.errors.lastName }}
                  </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col md=4>
              <b-form-group>
                <label class="required">Firstname : </label>
                <b-form-input :disabled="!isEditing" 
                  v-model="forms.personnel.fields.firstName"
                  :state="forms.personnel.states.firstName"
                  debounce="500" />
                  <b-form-invalid-feedback>
                    {{ forms.personnel.errors.firstName }}
                  </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col md=4>
              <b-form-group>
                <label >Middlename : </label>
                <b-form-input :disabled="!isEditing" 
                  v-model="forms.personnel.fields.middleName"
                  :state="forms.personnel.states.middleName"
                  debounce="500" />
                <b-form-invalid-feedback>
                    {{ forms.personnel.errors.firstName }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md=4>
              <b-form-group>
                <label class="required">Birthdate : </label>
                <b-form-datepicker :disabled="!isEditing"
                  v-model="forms.personnel.fields.birthDate"
                  :state="forms.personnel.states.birthDate" />
                <b-form-invalid-feedback>
                    {{ forms.personnel.errors.birthDate }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col md=4>
              <b-form-group>
                <label >Mobile No: </label>
                <b-form-input :disabled="!isEditing" 
                  v-model="forms.personnel.fields.mobileNo"
                  :state="forms.personnel.states.mobileNo"
                  debounce="500" />
                <b-form-invalid-feedback>
                    {{ forms.personnel.errors.mobileNo }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col md=4>
              <b-form-group>
                <label >Phone No : </label>
                <b-form-input :disabled="!isEditing"
                  v-model="forms.personnel.fields.phoneNo"
                  :state="forms.personnel.states.phoneNo"
                  debounce="500" />
                <b-form-invalid-feedback>
                  {{ forms.personnel.errors.phoneNo }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md=12>
              <b-form-group>
                <label class="required">Address : </label>
                  <b-form-textarea rows=4 :disabled="!isEditing"
                  v-model="forms.personnel.fields.address"
                  :state="forms.personnel.states.address"
                  debounce="500" />
                <b-form-invalid-feedback>
                  {{ forms.personnel.errors.address }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
        <div class="profile__section" :key="2" v-if="selectedIndex === 1">
          <b-row>
            <b-col md=6>
              <!-- <div class="account-header">Change Username</div> -->
              <b-form-group>
                <label class="required">Username : </label>
                <b-form-input :disabled="!isEditing" 
                  v-model="forms.user.fields.username"
                  :state="forms.user.states.userUsername"
                  debounce="500" />
                <b-form-invalid-feedback>
                  {{ forms.user.errors.userUsername }}
                </b-form-invalid-feedback>
              </b-form-group>
              <b-form-group>
                <label class="required">Old Password : </label>
                <b-form-input :disabled="!isEditing" type="password"  
                  v-model="forms.user.fields.oldPassword"
                  :state="forms.user.states.userOldPassword"
                  debounce="500" />
                <b-form-invalid-feedback>
                  {{ forms.user.errors.userOldPassword }}
                </b-form-invalid-feedback>
              </b-form-group>
              <b-form-group>
                <label class="required">New Password : </label>
                <b-form-input :disabled="!isEditing" type="password"
                  v-model="forms.user.fields.password"
                  :state="forms.user.states.userPassword"
                  debounce="500" />
                <b-form-invalid-feedback>
                  {{ forms.user.errors.userPassword }}
                </b-form-invalid-feedback>
              </b-form-group>
              <b-form-group>
                <label class="required">Confirm Password : </label>
                <b-form-input :disabled="!isEditing" type="password" 
                  v-model="forms.user.fields.passwordConfirmation"
                  :state="forms.user.states.userPasswordConfirmation"
                  debounce="500" />
                <b-form-invalid-feedback>
                  {{ forms.user.errors.userPasswordConfirmation }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
        <div class="profile__section" :key="3" v-if="selectedIndex === 2">
          <Full
            noCreateButton
            placeholder="Search Here..."
            :isServerSide="true"
            @search="loadContracts()"
            @paginate="loadContracts()"
            :filter="filters.contract"
            :table="tables.contracts"
            :pagination="paginations.contract"
            buttonLabel="Create New Contract">
            <template v-slot:cell(company)="data">
              <b-link @click="onContractToggleDetails(data)">{{ data.item.tradeName }}</b-link>
              <div class="row__contract-no">{{ data.item.contractNo }}</div>
            </template>
            <template v-slot:cell(contact)="data">
              <div>{{ data.item.contactPerson }}</div>
              <div class="row__contract-no">{{ data.item.contactNo }}</div>
            </template>
            <template v-slot:cell(tin)="{ item }">
              <div>{{ item.tin }}</div>
              <div class="row__contract-no">{{ `${item.taxType ? item.taxType.name : ''}${item.location ? ` / ${item.location.name} - ${item.location.rdo.name}` : ''}` }}</div>
            </template>
            <template v-slot:head(company) >
              <CustomToolTip id="company-icon" label="COMPANY">
                <template #body>
                  <div>
                    <div>Line 1 - Represents the tradename.</div>
                    <div class="row__contract-no">Line 2 - Represents the contract no.</div>
                  </div>
                </template>
              </CustomToolTip>
            </template>
            <template v-slot:head(contact) >
              <CustomToolTip id="contact-icon" label="CONTACT">
                <template #body>
                  <div>
                    <div>Line 1 - Represents the contact person</div>
                    <div class="row__contract-no">Line 2 - Represents the contact no.</div>
                  </div>
                </template>
              </CustomToolTip>
            </template>
            <template v-slot:head(tin) >
              <CustomToolTip id="tin-icon" label="TIN">
                <template #body>
                  <div>
                    <div>Line 1 - Represents the TIN</div>
                    <div class="row__contract-no">Line 2 - Represents the tax type and RDO.</div>
                  </div>
                </template>
              </CustomToolTip>
            </template>
            <template v-slot:cell(status)="data">
              <b-badge :variant="getContractStatusVariant(data.item.contractStatusId)">{{ data.item.contractStatus.name }}</b-badge>
            </template>
            <template #row-details="data">
              <ContractRowDetail :contract="data.item" :loading="rowLoading" />
            </template>
          </Full>
        </div>
        <!-- <div class="profile__section" :key="4" v-if="selectedIndex === 3">
          <Maintenance />
        </div> -->
        <!-- <div class="profile__footer">
          <SaveButton label="Update"></SaveButton>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import Avatar from '../components/Avatar'
import SaveButton from '../components/SaveButton'
import Full from '../components/Full'
import CustomToolTip from '../components/CustomToolTip'
import ContractRowDetail from '../components/ContractRowDetail'
import { copyValue } from '../../helpers/extractor';
import { PersonnelApi,ContractApi, AuthApi } from '../../mixins/api'
import { ContractStatuses } from '../../helpers/enum'
import Maintenance from '../components/Maintenance'
import { clearFields, formatNumber, reset, showNotification, validate } from '../../helpers/forms';
import PhotoViewer from '../components/PhotoViewer'

const personnelFields = {
  id: null,
  lastName: null,
  firstName: null,
  middleName: null,
  birthDate: null,
  mobileNo: null,
  phoneNo: null,
  address: null
}

const userFields = {
  username: null,
  oldPassword: null,
  password: null,
  passwordConfirmation: null
}

const userErrorFields = {
  userUsername: null,
  userOldPassword: null,
  userPassword: null,
  userPasswordConfirmation: null
}


export default {
  components: {
    Avatar,
    SaveButton,
    Full,
    CustomToolTip,
    ContractRowDetail,
    Maintenance,
    PhotoViewer
  },
  ContractStatuses,
  mixins:[ ContractApi, PersonnelApi, AuthApi ],
  data() {
    return {
      isLoading: false,
      isEditing: false,
      isProcessing: false,
      selectedIndex: 0,
      personnelPhotoUrl: null,
      isProfilePhotoBusy: false,
      headerKey: 0,
      forms: {
        personnel: {
          isProcessing: false,
          fields: { ...personnelFields },
          errors: { ...personnelFields },
          states: { ...personnelFields }
        },
        user: {
          isProcessing: false,
          fields: { ...userFields },
          errors: { ...userErrorFields },
          states: { ...userErrorFields }
        }
      },
      profileNavs: [
        {
          title: 'Profile',
          subTitle: 'Edit or change your profile details.',
          icon: 'user'
        },
        {
          title: 'Account',
          subTitle: 'Change or reset your access credentials.',
          icon: 'address-card'
        },
        {
          title: 'Clients',
          subTitle: "Here's a summary list of clients assigned to you.",
          icon: 'file-contract'
        },
        // {
        //   title: 'Settings',
        //   subTitle: 'View and edit your global settings and preferences.',
        //   icon: 'cogs'
        // },
      ],
      tables: {
        contracts: {
          isBusy: false,
          fields: [
            {
              key: 'company',
              label: 'Company',
              thClass: 'align-middle',
              thStyle: { width: '25%' },
            },
            {
              key: 'billingAddress',
              label: 'Billing Address',
              thClass: 'align-middle',
              thStyle: { width: 'auto' },
            },
            {
              key: 'tin',
              label: 'TIN',
              thClass: 'align-middle',
              thStyle: { width: '24%' },
            },
            {
              key: 'contact',
              label: 'Contact',
              thClass: 'align-middle',
              thStyle: { width: '14%' },
            },
            {
              key: 'status',
              label: 'Status',
              thClass: 'align-middle text-center',
              tdClass: 'align-middle text-center',
              thStyle: { width: '100px' },
            },
          ],
          items: []
        }
      },
      paginations: {
        contract: {
          from: 0,
          to: 0,
          totalRows: 0,
          page: 1,
          perPage: 10,
        }
      },
      filters: {
        contract: {
          criteria: null,
        }
      },
    }
  },
  methods: {
    onPhotoChange(file) {
      this.isProfilePhotoBusy = true
      const formData = new FormData();
      const { id: personnelId } = this.forms.personnel.fields;
      formData.append('photo', file);

      this.savePhoto(formData, personnelId).then(({ data }) => {
        this.personnelPhotoUrl = `${process.env.VUE_APP_PUBLIC_PHOTO_URL}personnels/${data.hashName}`
        setTimeout(() => (this.isProfilePhotoBusy = false), 2000);
      });
    },
    onPhotoRemove() {
      const { id: personnelId } = this.forms.personnel.fields;

      this.deletePhoto(personnelId).then(({ data }) => {
        this.personnelPhotoUrl = '';
      });
    },
    onContractToggleDetails(row) {
      const contractId = row.item.id
      if(!row.detailsShowing) {
        this.rowLoading = true
        this.getContract(contractId).then(({ data }) => {
          copyValue(data, row.item)
          this.$set(row.item, 'services', data.services)
          this.$set(row.item, 'charges', data.charges)
          this.$set(row.item, 'location', data.location)
          this.$set(row.item, 'taxType', data.taxType)
          this.$set(row.item, 'assignedPersonnel', data.assignedPersonnel)
          this.$set(row.item, 'approvedByPersonnel', data.approvedByPersonnel)
          this.rowLoading = false 
        })
      }
      row.toggleDetails()
    },
    loadContracts() {
      const { contracts } = this.tables
      const { contract, contract: { perPage, page } } = this.paginations
      const { criteria } = this.filters.contract

      const params = {
        paginate: true,
        perPage,
        page,
        criteria,
      }

      contracts.isBusy = true

      this.getContractList(params)
      .then(({ data }) => {
        contracts.items = data.data
        contract.from = data.meta.from
        contract.to = data.meta.to
        contract.totalRows = data.meta.total
        contracts.isBusy = false
      })
    },
    getContractStatusVariant(contractStatusId) {
      if (contractStatusId === this.$options.ContractStatuses.PENDING.id) {
        return 'warning'
      }
      else if (contractStatusId === this.$options.ContractStatuses.APPROVED.id) {
        return 'success'
      }
      else {
        return 'danger'
      }
    },
    onNavIndexChange(index) {
      this.selectedIndex = index
      this.isEditing = false
      this.loadProfile()
    },
    onSave() {
      this.isProcessing = true

      // setTimeout(() => {
      //   this.isEditing = false
      //   this.isProcessing = false
      // }, 2000);

      if (this.selectedIndex === 0) {
        //personnel profile saving
        const { fields, fields: { id: personnelId } } = this.forms.personnel
        const { personnel } = this.forms 
        reset(personnel)
        this.updatePersonnel(fields, personnelId).then(({ data }) => {
          copyValue(data, fields)
          this.isEditing = false
          this.isProcessing = false
          showNotification(this, 'success', 'Profile has been updated successfully.')
        }).catch(error => {
          const errors = error.response.data.errors
          // this.isEditing = false
          this.isProcessing = false
          validate(personnel, errors)
        })

      }
      else if(this.selectedIndex === 1) {
        //user account saving
        const { fields: { id: personnelId } } = this.forms.personnel
        const { personnel, user,  user: { fields: { username, oldPassword, password, passwordConfirmation }} } = this.forms 
        reset(user)

        let data = {}

        if(password != null) {
          //username and change password
          data = {
          id: personnelId,
            user: {
              username,
              oldPassword,
              password,
              passwordConfirmation
            }
          }
        }
        else {
          //username update
          data = {
          id: personnelId,
            user: {
              username,
              oldPassword
            }
          }
        }
        

        this.updatePersonnel(data, personnelId).then(({ data }) => {
          copyValue(data, personnel.fields)
          copyValue(data.user, user.fields)
          this.isEditing = false
          this.isProcessing = false
          showNotification(this, 'success', 'Account has been updated successfully.')
          user.fields.password = null
          user.fields.oldPassword = null
          user.fields.passwordConfirmation = null
        }).catch(error => {
          const errors = error.response.data.errors
          // this.isEditing = false
          this.isProcessing = false
          validate(user, errors)
        })
      } 
    },
    loadProfile() {
      this.isLoading = true
      const { personnel, user } = this.forms
      this.isProfilePhotoBusy = true
      const { userable, ...data } = this.user
      // this.getAuthenticatedUser().then(({ data }) => {
      copyValue(data, user.fields)
      if(userable) {
        copyValue(userable, personnel.fields)
        this.personnelPhotoUrl = userable.photo ? `${process.env.VUE_APP_PUBLIC_PHOTO_URL}personnels/${userable.photo.hashName}` : ''
      }
      this.isLoading = false 
      this.isProfilePhotoBusy = false
      // })
    }
  },
  created() {
    // console.log(this.user)
    if (this.user) {
      this.loadProfile()
    }
    // this.loadProfile();
    this.loadContracts()
  },
  computed: {
    user() {
      return this.$store.state?.user
    }
  },
  watch: {
    user() {
      this.loadProfile()
    }
  }
}
</script>

<style lang="scss" scoped>

  .profile__main-container {
    height: 100%;
    width: 100%;
    border: solid 1px lightgray;
    margin-bottom: 20px;
    background-color: white;
    -webkit-box-shadow: 0px 0px 8px 0.5px #757575;
    box-shadow: 0px 0px 8px 0.5px #757575;
    position: fixed;
  }

  .profile__body-container {
    width: 100%;
    height: 100%;
    display: flex;
    background-color: white;
    position: relative;
    

    .profile__left-pane {
      min-width: 250px;
      background-color: rgb(247, 236, 236);
      min-height: calc(100vh - 100px);
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 30px 10px 10px;
      color: gray;

      .profile-name {
        font-size: 14pt;
        font-weight: bold;
        margin-top: 10px;
      }

      .profile-username, .profile-usergroup {
        font-size: 10pt;
        margin-top: 4px;
      }

    }

    .profile__right-pane {
      flex: 1;
      height: 100%;
      padding: 40px 60px;
      position: relative;
      overflow-y: auto;

      .profile__nav-title {
        font-size: 15pt;
        font-weight: bold;
        color: gray;
      }

      .profile__nav-sub-title {
        font-size: 10pt;
        color: rgb(197, 194, 194);
      }

      .profile__footer {
        position: sticky;
        bottom: 0;
        height: 60px;
        background-color: white;
        border: sold 1px;
      }
    }
  }

  .profile-nav {
    padding: 0;
    margin-top: 10px;
    list-style: none;
    width: 100%;

    .profile-nav-item {
      padding: 0 20px;
      width: 100%;
      margin: 5px 0;
      font-size: 14pt;
      height: 48px;
      display: flex;
      align-items: center;
      transition: all 0.3s ease;

      .profile-nav-item-icon {
        margin-right: 8px;
      }

      &.active {
        border-left: solid 10px rgb(98, 190, 221);
        background-color: white;
        font-weight: bold;
      }

      &:hover {
        cursor: pointer;
      }
    }
  }

  .profile__section {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    width: 100%;
    min-height: 100%;
    
    .profile__row-section {
      display: flex;
      width: 100%;
      height: auto;
      margin-bottom: 10px;
      border:solid 1px;
    }
  }

  .account-header {
    font-weight: bold;
    font-size: 14pt;
    margin-bottom: 10px;
  }

  .account-update-button {
    margin-bottom: 10px;
  }

  .account-button-container {
    display: flex;
    justify-content: flex-end;
  }
  
  .profile__header {
    position: relative;
  }
  .profile__button {
    position: absolute;
    right: 0;
    top: 0;
    height: 40px;
    width: 40px;
    display: flex;
    justify-content: center;
    align-items: center;

    .profile__button-icon {
      width: 24px;
      height: 24px;
    }

    &:hover {
      cursor: pointer;
      background-color: rgb(80, 174, 206);
      border-radius: 5px;

      .profile__button-icon {
        color: white;
      }
    }

  }

  .profile-photo {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    border: solid 6px rgb(228, 224, 224);
    // border: solid 1px lightgray;
  }

  .row__contract-no {
    font-size: 8pt!important;
    color: gray!important;
  }
</style>